import React, { useState, useEffect } from 'react';
import { db, ref, set, onValue, auth, get } from '../Firebase/firebase-config';
import { onAuthStateChanged } from 'firebase/auth';
import { getDatabase } from 'firebase/database';
import "./TransportGoods.css";
import { v4 as uuidv4 } from 'uuid';
import { FaInfoCircle } from 'react-icons/fa';
const gifUrl = "/Images/New notification.gif"

const TransportGoods = () => {
    const [userId, setUserId] = useState(null);
    const [formData, setFormData] = useState({
        destinationFrom: '',
        destinationTo: '',
        commodity: '',
        quantity: '',
        companyName: ''
    });
    const [requests, setRequests] = useState([]);
    const [replies, setReplies] = useState({});
    const [success, setSuccess] = useState(false);
    const [showResponses, setShowResponses] = useState(false);
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(true);
const [sessionError, setSessionError] = useState("");


    const commodityOptions = ['Cement', 'Steel'];
    const getIndianTimestamp = () => {
        const now = new Date();
        const istOffset = 5.5 * 60 * 60 * 1000; // IST is UTC+5:30
        const istTime = new Date(now.getTime() + istOffset);
        return istTime.toISOString().replace("T", " ").replace("Z", "");
      };

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, (user) => {
            if (user) setUserId(user.uid);
            else setUserId(null);
        });
        return () => unsubscribe();
    }, []);
    useEffect(() => {
  const dbInstance = getDatabase();
  const connectedRef = ref(dbInstance, ".info/connected");

  if (!navigator.onLine) {
    setSessionError("You are offline. Please check your internet connection.");
    setLoading(false);
    return;
  }

  const unsubscribeAuth = onAuthStateChanged(auth, (user) => {
    if (!user) {
      setSessionError("Session expired. Please login again.");
      setLoading(false);
      return;
    }
  setSessionError("");
    setUserId(user.uid);

    onValue(connectedRef, (snap) => {
      if (snap.val() === false) {
        setSessionError("Session expired. Please login again.");
        setLoading(false);
        return;
      }
  setSessionError("");
      const userTransportRef = ref(dbInstance, `transport_goods/${user.uid}`);

      onValue(userTransportRef, (snapshot) => {
        if (snapshot.exists()) {
          const transportRequests = snapshot.val();
          setRequests(transportRequests);
        } else {
          setRequests({});
        }
        setLoading(false);
      });
    });
  });

  return () => unsubscribeAuth();
}, []);


    useEffect(() => {

        if (!userId) return;
        const userTransportRef = ref(db, `transport_goods/${userId}`);

        onValue(userTransportRef, (snapshot) => {
            if (snapshot.exists()) {
                const transportRequests = snapshot.val(); 
                setRequests(transportRequests); // Keep all request details unchanged
            } else {
                console.log("No transport data found.");
                setRequests({});
            }
        });
    }, [userId]);

    const sendNotification = async (userId, transportId, companyName) => {
        //   const db = getDatabase()
        const notificationRef = ref(db, `supplier_notifications/transportGoods/${userId}/${transportId}`)

        const newNotification = {
            companyName,
            title: "TransportGoods",
            message: `A transport goods request has been sent by ${companyName}. Please review the query details.`,
            gifUrl,
            timestamp: getIndianTimestamp(),
            seen: false,
        }

        try {
            await set(notificationRef, newNotification)
        } catch (error) {
            console.error("Error sending notification:", error)
        }
    }
    const getSupplierClass = (supplierName) => {
        const brandClasses = {
            "Ultratech": "ultratech",
            "Shree": "shree",
            "JSW": "jsw",
            "JKSuper": "jksuper",
            "ACC": "acc",
            "Ambuja": "ambuja"
        };
        return brandClasses[supplierName] || "default"; // Default class if no match
    };


    useEffect(() => {
        if (!userId) return;
        const repliesRef = ref(db, `transport_goods_replies/${userId}`);

        onValue(repliesRef, (snapshot) => {
            if (snapshot.exists()) {
                const fetchedReplies = snapshot.val();
                setReplies(fetchedReplies); // Store replies separately without affecting transport requests
            } else {
                console.log("No supplier replies found.");
                setReplies({});
            }
        });
    }, [userId]);

    

    const handleChange = (e) => {
        const { name, value } = e.target;
        let newValue = value;

        if (name === "quantity") {
            if (value > 100000) {
                setError("You cannot enter more than 100000 bags.");
            } else {
                setError(""); // Clear error if within limit
            }
        }

        setFormData({ ...formData, [name]: newValue });
    };


    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!userId) {
            alert('You must be logged in to submit.');
            return;
        }
        if (formData.quantity > 100000) {
            alert("Quantity must not exceed 100000 bags.");
            return;
        }

        const transportId = uuidv4();
        const timestamp = getIndianTimestamp(); // Get IST timestamp
        try {

            const profileRef = ref(db, `profileDashboard/${userId}`)
            const snapshot = await get(profileRef)
            const companyName = snapshot.exists() ? snapshot.val().company_name || "Not Specified" : "Not Specified"
            const newRef = ref(db, `transport_goods/${userId}/${transportId}`);
            await set(newRef, { ...formData, companyName, timestamp });
            setSuccess(true);
            setTimeout(() => setSuccess(false), 3000);
            setFormData({ destinationFrom: '', destinationTo: '', commodity: '', quantity: '', companyName });
            await sendNotification(userId, newRef.key, companyName)
        } catch (error) {
            console.error('Error processing transport goods:', error);
            alert('There was an error processing your request. Please try again later.');
        }
    };
    if (loading) {
  return <div className="loading-container"><div className="loader"></div></div>;
}

if (sessionError) {
  return <div className="error">{sessionError}</div>;
}


    return (
        <div className='container-fluid transport-fluid'>
            <div className='transport-goods-container'>

                {/* Left: Transport Form */}
                <div className='transport-form-container'>
                    <h3 className='text-center fw-bold trans-text' >
                        Transport Goods <FaInfoCircle style={{ fontSize: '18px', color: '#ea8716', cursor: 'pointer' }} onClick={() => alert("Submit transport details and receive supplier responses.")} />
                    </h3>

                    <form onSubmit={handleSubmit}>
                        <div className='transport-form'>
                            <label className='transport-label'>Destination From</label>
                            <input type="text" name="destinationFrom" value={formData.destinationFrom} onChange={handleChange} required className='transport-input' />
                        </div>
                        <div className='transport-form'>
                            <label className='transport-label'>Destination To</label>
                            <input type="text" name="destinationTo" value={formData.destinationTo} onChange={handleChange} required className='transport-input' />
                        </div>
                        <div className='transport-form'>
                            <label className='transport-label'>Commodity</label>
                            <select name="commodity" value={formData.commodity} onChange={handleChange} required className='transport-input'>
                                <option value="">Select a commodity</option>
                                {commodityOptions.map((commodity, index) => (
                                    <option key={index} value={commodity}>{commodity}</option>
                                ))}
                            </select>
                        </div>
                        <div className='transport-form'>
                            <label className='transport-label'>Quantity (bags)</label>
                            <input
                                type="number"
                                name="quantity"
                                value={formData.quantity}
                                onChange={handleChange}
                                min={1}
                                required
                                className='transport-input'
                                onWheel={(e) => e.target.blur()}
                            />
                            {error && <p className="error-message" style={{ color: 'red', fontSize: '14px' }}>{error}</p>}
                        </div>

                        <button type="submit" className='transport-submit'>Submit</button>
                        {success && <div className="success-message">Form submitted successfully!</div>}
                    </form>
                </div>

                {/* Right: Supplier Responses */}
                <div className="supplier-replies">
                    <h4 className='text-center fw-bold'>Supplier Replies</h4>
                    {Object.keys(requests).length === 0 ? (
                        <p className='text-danger fw-bold text-center'>No requests found.</p>
                    ) : (
                        Object.entries(requests).map(([transportId, requestData]) => (
                            <div key={transportId} className="transport-request-card">
                                {/* Always show request details */}
                                <p><strong>From:</strong> {requestData.destinationFrom || 'N/A'}</p>
                                <p><strong>To:</strong> {requestData.destinationTo || 'N/A'}</p>
                                <p><strong>Commodity:</strong> {requestData.commodity || 'N/A'}</p>
                                <p><strong>Quantity:</strong> {requestData.quantity || 'N/A'} (bags)</p>

                                {/* Display supplier replies if available */}
                                {replies[transportId] ? (
                                    Object.entries(replies[transportId]).map(([supplierId, reply]) => (
                                        <div key={supplierId} className={`supplier-reply ${getSupplierClass(supplierId)}`}>
                                            <p><strong>Supplier:</strong> {supplierId}</p>
                                            <p><strong>Price:</strong> {reply.price}</p>
                                            <p><strong>Availability:</strong> {reply.availability}</p>
                                            <p><strong>Estimated Delivery:</strong> {reply.estimatedDelivery}</p>
                                            <p><strong>Transporter:</strong> {reply.transporter?.name} (Contact: {reply.transporter?.contact})</p>
                                            {reply.notes && <p><strong>Notes:</strong> {reply.notes}</p>}
                                        </div>

                                    ))
                                ) : (
                                    <p className='text-danger fw-bold'>No supplier replies yet.</p>
                                )}
                            </div>
                        ))
                    )}
                </div>

            </div>
        </div>
    );
};

export default TransportGoods;
